import type { RootState } from 'store';
import drmSlice, { type AssetPayload } from './slice';

export function getDrmIngest(state: RootState, { provider, id }: AssetPayload) {
    return state.video?.[drmSlice.name]?.[`${provider}:${id}`]?.drm;
}
